export const delay = (fn, ms) => new Promise((resolve) => setTimeout(() => {
	fn()
	resolve()
}, ms));



// WEBPACK FOOTER //
// ./scripts/modules/helpers.js